// Module
var code = "<div> <div v-if=\"chartDefinitionForm != null\" class=\"chart-options\"> <table-options v-if=\"chartDefinitionForm.ChartType == chartTypes.Table\" :client-data.sync=\"chartDefinitionForm.ClientData\"></table-options> </div> </div> ";
// Exports
export default code;